export enum ProjectTempType {
  Project = 1,
  Template = 2
}


export enum ProjectTempStep {
  Step0 = 0,
  Step1 = 1,
  Step2 = 2,
  Step3 = 3,
  Step4 = 4,
}

export enum FormAuditType {
  NormalForm = 1,
  AuditForm = 2,   
}

export enum PlaceholderStatus {
  Empty=0,
  FormSelected=1,
  ProjectCreated=2,
  ProjectSent=3,
  ProjectCompleted=4
}

export enum FormOrShared {
  MyForm="MyForm",
  SharedWithMe="SharedWithMe",   
}

export enum RoleLevel {
  SuperAdmin=1,
  OrganizationAdmin=2,
  OfficeAdmin=3,
  User=11,
}

export enum MasterTemplateCategory{
   Save = 1,
   Modify=2,
   Delete=3, 
   HardDelete=4,
   Rename=5,
   ChangeStatus=6
  }

  export enum ModuleName{
    Core= "Core",
    Contact= "Contact",
    Company ="Company",
    Task="Task"
   }
   
   export enum MessageTemplate {  
    BroadCast=1,
    RequestDocument=2,
    Fax=3,
    Project=4
  }

  export enum RequestType {  
    RequestDocument=1,
    Email=2,
    Fax=3,   
  }

  export enum NAVIGATION {
    AIData = "AI Data",
    KeyValueData= "Key Value",
    CODES = "CODES",
    QUESTIONS = "QUESTIONS",
    AICHAT = "AI Chat"
  };

  export enum OCRType {
    MyTemplate = 0,
    OrganizationTemplate= "1"   
  };

  export enum ProcessStagesType {
  Dashboard = 1,
  PDPM = 2
}